<template>
   <div class="breadcrumb-bar-two yd-crumb-compact">
            <div class="container">
                <div class="row align-items-center inner-banner">
                    <div class="col-md-12 col-12">
                        <h2 class="breadcrumb-title">{{ title }}</h2>
                        <nav aria-label="breadcrumb" class="page-breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/doctor-dashboard">{{ text }}</router-link></li>
                                <li class="breadcrumb-item" aria-current="page">{{text1  }}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        text1: {
            type: String,
            default: "",
        },

    }
}
</script>

<style>
/* Doctor pages: a slim title strip instead of the site's tall page banner.
   The site header is overlaid on this strip, so its top padding is the
   header's height. Selectors carry the base class so they beat style.css. */
.breadcrumb-bar-two.yd-crumb-compact {
    min-height: 0;
    padding-top: 68px;
}

/* A slimmer site header on doctor pages (it only holds the logo and menu). */
body:has(.yd-crumb-compact) .header-one .header-nav {
    height: 68px;
}

body:has(.yd-crumb-compact) .header-one .navbar-brand.logo img {
    max-height: 40px;
    width: auto;
}

.breadcrumb-bar-two.yd-crumb-compact .inner-banner {
    padding: 2px 0 14px;
}

.breadcrumb-bar-two.yd-crumb-compact .inner-banner .breadcrumb-title {
    font-size: 26px;
    margin-bottom: 0;
}

.breadcrumb-bar-two.yd-crumb-compact .page-breadcrumb ol {
    font-size: 13px;
}

.breadcrumb-bar-two.yd-crumb-compact + .content {
    padding-top: 24px;
}

/* Use the screen: the site's 1320px container leaves wide empty margins on
   big monitors. The header shares the width so logo and menu line up. */
.breadcrumb-bar-two.yd-crumb-compact > .container,
.breadcrumb-bar-two.yd-crumb-compact + .content > .container,
body:has(.yd-crumb-compact) header.header > .container,
body:has(.yd-crumb-compact) header.header .container {
    max-width: 1600px;
    padding-left: 24px;
    padding-right: 24px;
}

@media (max-width: 991.98px) {
    .breadcrumb-bar-two.yd-crumb-compact {
        padding-top: 68px;
    }

    .breadcrumb-bar-two.yd-crumb-compact .inner-banner .breadcrumb-title {
        font-size: 22px;
    }
}
</style>
